export function fromIdName<VT, T extends { id: VT; name: string }>(items: T[]) {
	return items.map((x) => {
		const result: T & { value?: VT; label?: string } = { ...x };
		result.value = x.id;
		result.label = x.name;

		delete result.id;
		delete result.name;

		return result as Omit<T, 'id' | 'name'> & { value: VT; label: string };
	});
}
